import type { SlideDeckMaterial } from '@breakoutlearning/firebase-repository/models/SlideDeckMaterial'

export function sortPreWorkMaterials(materials: SlideDeckMaterial[]) {
  return materials
    .filter((material) => material.isPreWork)
    .sort((a, b) => {
      // sort mp3 above pdf
      if (b.data.materialType !== a.data.materialType)
        return b.data.materialType - a.data.materialType

      // if both have a material order, compare them
      if (
        a.data.materialOrder !== undefined &&
        b.data.materialOrder !== undefined
      )
        return a.data.materialOrder - b.data.materialOrder

      // if only one has a material order, put it first
      if (a.data.materialOrder !== undefined) return -1

      if (b.data.materialOrder !== undefined) return 1

      return 0
    })
}
